<template>
    <PopupTemplate
        v-if="shouldShow"
        v-model="isOpen"
        :img-src="imgSrc"
        img-alt="Trial ended"
        :title="t('vue.extend_your_trial')"
        :body-text="t('vue.extend_your_trial_action_step')"
        @close="dismissed = true"
    >
        <template #actions>
            <AtomicButton
                color="yellow"
                size="lg"
                class="border-transparent bg-[#088BEA] text-white hover:text-gray-100 focus:ring-[#088BEA] disabled:bg-gray-300 disabled:text-white"
                @click="addDomainAction"
            >
                {{ t("vue.add_your_first_domain") }}
            </AtomicButton>
        </template>
    </PopupTemplate>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { router, usePage } from "@inertiajs/vue3";
import route from "ziggy-js";

import PopupTemplate from "@/components/Atomic/Dialogs/PopupTemplate.vue";
import AtomicButton from "@/components/Atomic/Buttons/AtomicButton.vue";
import { useTranslations } from "@/composables/useTranslations";
import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";

const { t } = useTranslations();
const page = usePage<IRhizomPageProps>();

const shouldShow = computed(() => {
    const isTrialing = page.props.isTrialing;
    const hadActiveDomain = page.props.hadActiveDomain;

    return isTrialing && !hadActiveDomain;
});

const imgSrc = new URL(
    "/resources/js/assets/images/special-offer-calendar.svg",
    import.meta.url,
).href;

const isOpen = ref(false);
const dismissed = ref(false);

watch(
    shouldShow,
    (show) => {
        if (!show) {
            dismissed.value = false;
            isOpen.value = false;
            return;
        }
        if (!dismissed.value) isOpen.value = true;
    },
    { immediate: true },
);

watch(isOpen, (openNow) => {
    if (!openNow) dismissed.value = true;
});

function addDomainAction() {
    const currentRouteName = route().current();

    const allowed = new Set(["domainGuide.index", "domains.index"]);
    const isAllowed = currentRouteName != null && allowed.has(currentRouteName);

    if (!isAllowed) {
        router.visit(route("domains.index"));
    }

    isOpen.value = false;
    dismissed.value = true;
}
</script>
